import { FC } from "react";
import { FieldHookConfig, useField } from "formik";

import InputFieldAuthHide from "../../InputFieldAuthHide/InputFieldAuthHide";
import { InputFieldProps } from "../../InputField/types";



const FormikInputFieldHide: FC<InputFieldProps & FieldHookConfig<string>> = (
  props: InputFieldProps & FieldHookConfig<string>
) => {
  const [field, meta] = useField(props);

  return (
    <InputFieldAuthHide
      {...props}
      {...field}
      {...(meta.touched &&
        meta.error &&
        props.type !== "hidden" && { errorMessage: meta.error })}
    />
  );
};

export default FormikInputFieldHide;
